'use strict';

/*! home.js */

$(function () {
  $('.js-tab').on('click', function (e) {
    e.preventDefault();
    $(this).toggleClass('activa').siblings().removeClass('activa');
    $('.' + $(this).attr('data-target')).slideToggle().siblings('.js-content').slideUp();
  });
  $('.js-tab').first().trigger('click');

  $(".h-slider").slick({
    autoplay: true,
    autoplaySpeed: 5000,
    speed: 300,
    dots: true
  });

  refError();
});

function refError() {
  if (ref_pedida !== 'null' && ref_pedida && !error_referencia) {
    console.log(ref_pedida, error_referencia);
    $('.js-home-results-ref').show().find('.js-home-ref').text(ref_pedida);
  }
  if (typeof listaModelos !== 'undefined') {
    if (listaModelos.turismos.length == 0) $('.js-turismos').hide();
    if (listaModelos.comerciales.length == 0) $('.js-comerciales').hide();
  }
}